import * as React from 'react';
import { Row, Col, Form, Button, DatePicker, Input, Tooltip, Icon, Layout } from 'antd';
import FilterTextbox from 'components/Forms/DataGrid/FilterTextbox';
import InfoIcon from 'components/Forms/InfoIcon';
import FormControl from 'components/Forms/FormControl';
import { FormComponentProps } from 'antd/lib/form';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { StyleCargoChargesSearch as StyleCargoChargesSearchForm, ButtonColLayout } from './CargoChargesSearchBar.Style';
import moment, { Moment } from 'moment';
import { centeredRowAttributes } from 'components/Styled/Layout.Styled';
import ConfigUtility from 'Core/ConfigUtility';
import AuthContext from 'Context/AuthContext';
import { SubmitButton } from 'components/SubmitButton';
import ShowIfTrue from 'components/Forms/ShowIfTrue';
import Utility from 'Core/Utility';
import { DateInJamaicaLabel } from 'components/Forms/DateInJamaicaLabel';
// import { InfoCircleOutlined } from '@ant-design/icons';

export interface Props extends FormComponentProps, RouteComponentProps {
  children?: React.ReactNode;
  search(bolNumber: string, storageDate: Moment): any; //pass search model
}

export interface State {
  localTimeZone?: number;
  selectedDate?: Moment;
}

class BaseCargoChargesSearchBar extends React.Component<Props, State> {
  static contextType = AuthContext;
  config = ConfigUtility.getSync();
  context!: React.ContextType<typeof AuthContext>;
  constructor(props: Props) {
    super(props);
    this.onSearch = this.onSearch.bind(this);

    this.state = {};
  }

  formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };

  inputColSize = {
    xs: { span: 20 },
    sm: { span: 20 },
    //:   md={{ spa,: 8, offset: 8 }}
    lg: { span: 15 },
    xl: { span: 15 },
  };

  componentDidMount() {
    this.setState({ localTimeZone: moment().utcOffset() / 60 });
  }

  onSearch(event: React.FormEvent) {
    event.preventDefault();

    this.props.form.validateFieldsAndScroll((error, values: any) => {
      if (!error) {
        let fullDate = values.storageDate as Moment;
        // Converts the time to the country (Jamaica in this case) timezone
        let localizedDate = Utility.ConvertToStandardTimezone(fullDate);

        this.props.search(values.bolNumber, localizedDate);
        this.props.form.resetFields();
      }
    });
  }



  //NEED A CLEAR SEARCH BAR
  render() {
    // var {SearchBar_Search} = this.props;
    const { getFieldDecorator } = this.props.form;
    const config = ConfigUtility.getSync();
    const dateFormat = config?.Display?.DateFormat;
    const landingNumberToolTip = (
      <p style={{ textAlign: 'center', margin: 'auto' }}>
        {`A Bill of Lading number is a unique number used to identify the cargo you have shipped. This number is provided to you by your shipping agent`}
      </p>
    );
    const pickupDateToolTip = (
      <p style={{ textAlign: 'center', margin: 'auto' }}>
        {`Select the date you intend to pick-up your cargo. This date is used to calculate all charges that are due up to that date`}
      </p>
    );

    return (
      // <Form onSubmit={this.onSearch}>
      <StyleCargoChargesSearchForm onSubmit={this.onSearch}>
        <Row type="flex">
          <Col span={24}>
            <Row >
              <Col >
                <Row>
                  <Col span={23}>
                    <FormControl
                      getFieldDecorator={getFieldDecorator}
                      rules={[{ required: true, message: 'Please enter a Bill of Lading Number' }]}
                      name="bolNumber">

                      <Input placeholder="Enter Bill of Lading Number" />

                    </FormControl>
                  </Col>
                  <Col span={1}>
                    <Tooltip title={landingNumberToolTip}>
                      <Icon type='info-circle' style={{ color: 'rgba(0,0,0,.25)' }} />
                    </Tooltip>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col>
                <ShowIfTrue condition={(moment().utcOffset() / 60) != config?.Display.StandardTimeZone} ><div style={{ fontWeight: "bold", textAlign: "center" }}>Your Time Zone places you outside of Jamaica.<br /> Pickup Date selected will be converted to the Jamaican equivalent.</div></ShowIfTrue>
              </Col>
            </Row>
            <Row >
              <Col >
                {/* <Layout></Layout> */}
                <Row>
                  <Col span={23}>
                    <FormControl
                      getFieldDecorator={getFieldDecorator}
                      colon={false}
                      required={false}
                      rules={[{ required: true, message: 'Please enter a Pickup Date' }]}
                      name="storageDate">

                      <DatePicker renderExtraFooter={() => <DateInJamaicaLabel date={this.state.selectedDate} />} placeholder="Select a Pickup Date" onChange={(date) => this.setState({ selectedDate: date?.clone() ?? undefined })} className="datePicker" format={dateFormat} disabledDate={Utility.getDisableBOLDates()} />

                    </FormControl>
                  </Col>
                  <Col span={1}>
                    <Tooltip title={pickupDateToolTip}>
                      <Icon type='info-circle' style={{ color: 'rgba(0,0,0,.25)' }} />
                    </Tooltip>
                  </Col>
                </Row>

              </Col>
            </Row>
            <Row type="flex" style={{ alignItems: "center", justifyContent: "center" }}>
              <Col {...ButtonColLayout}>
                <Form.Item>
                  <SubmitButton icon="search" type="primary" htmlType="submit" className="login-form-button" style={{ textAlign: "center" }}>Search BL</SubmitButton>
                </Form.Item>
              </Col>
              {/* {this.context.data?.customerCode ? */}
              {/* <Col  {...ButtonColLayout}>
                <Form.Item>
                  <Button type="primary" className="login-form-button" onClick={this.props.getCustomerBol}>
                    Get Customer BL
                  </Button>
                </Form.Item>
              </Col> */}
              {/* :
                null
              } */}
            </Row>
          </Col>
        </Row >
      </StyleCargoChargesSearchForm >
    );
  }

  DisableDates() {
    if (this.state.localTimeZone! > this.config!.Display!.StandardTimeZone) {
      return (current) => current ? (current && current < moment().add(-2, "day")) : (false);
    } else {
      return (current) => current ? (current && current < moment().add(-1, "day")) : (false);
    }
  }
}

const CargoChargesSearchBarWithoutRouter = Form.create<Props>({
  name: 'CargoChargesSearchBar',
})(BaseCargoChargesSearchBar);

const CargoChargesSearchBar = withRouter(CargoChargesSearchBarWithoutRouter);

export default CargoChargesSearchBar;
